import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BcmApi2Service } from '@modules/bcm/@shared/services';
import { Notification } from '@shared/models/notification';

export class NotificationsApiService extends BcmApi2Service {

    private RESOURCE_ENDPOINT = 'notifications';

    protected getAll(params: HttpParams = new HttpParams()): Observable<Notification[]> {
        return super.get<Notification[]>(this.RESOURCE_ENDPOINT, params);
    }

    protected getOne(id: number, params: HttpParams = new HttpParams()): Observable<Notification> {
        return super.get<Notification>(`${this.RESOURCE_ENDPOINT}/${id}`, params);
    }

    protected updateRead(notification: Notification): Observable<Notification> {
        return super.post<Notification>(`${this.RESOURCE_ENDPOINT}/${notification.id}/read`, notification);
    }

    protected updateDelete(notification: Notification): Observable<Notification> {
        return super.post<Notification>(`${this.RESOURCE_ENDPOINT}/${notification.id}/delete`);
    }
}
